import { dark } from './dark'
import { light } from './light'

const theme = { dark, light }

export default theme;